function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function playAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"play"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.play());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.play();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__tab-btn):not(.slider-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - 20}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (document.querySelector('#tidio-chat-iframe') != null) {
          document.querySelector('#tidio-chat-iframe').style.display = 'none';
        }
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (document.querySelector('#tidio-chat-iframe') != null) {
      document.querySelector('#tidio-chat-iframe').style.display = 'block';
    }

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.headerWrapper = this.headerWrapper || document.querySelector('.header-wrapper');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    this.headerWrapper.classList.add('has-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    this.headerWrapper.classList.remove('has-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - 20}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach(button => button.addEventListener('click', this.hide.bind(this, false)));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
    if (this.classList.contains('open-on-load')) {
      setTimeout(() => {
        this.show();
      }, 2000);
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();

    if(this.classList.contains('popup-modal--engraving')){
      this.handleEngravingContext(opener);
    }
  }

  handleEngravingContext(opener) {
    const template = opener.querySelector('template');
    const content = this.querySelector('.popup-modal__content-info');

    if(!template || !content) return;

    content.innerHTML = template.innerHTML;
    content.setAttribute('data-context', opener.getAttribute('data-context'));
    
    if(opener.dataset.context === 'cart-edit'){
      content.querySelector('text-limited input').value = opener.dataset.text;
      content.querySelector('text-limited').updateInformations();

      const activeFont = content.querySelector(`input[value="${opener.dataset.font}"`);
      activeFont.setAttribute('checked', '');
      content.querySelector('engraving-font').handleFontChange(activeFont);

      content.setAttribute('data-line-index', opener.dataset.lineIndex);
      content.setAttribute('data-text-key', opener.dataset.textKey);
      content.setAttribute('data-font-key', opener.dataset.fontKey);
      content.setAttribute('data-variant-id', opener.dataset.variantId);
    }
  }

  hide() {
    this.classList.add('modal-dialog--closing');

    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    setTimeout(() => {
      this.removeAttribute('open');
      this.classList.remove('modal-dialog--closing');
    }, 150);
    removeTrapFocus(this.openedBy);

    const engravingSubmit = document.querySelector('engraving-submit');

    if(engravingSubmit) {
      engravingSubmit.closest('.popup-modal__content-info').innerHTML = '';
    }

    //window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class TextLimited extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.updateTextLimitation();
    this.updatePreviewImageText();
  }

  updateTextLimitation(){
    this.input = this.querySelector('input');
    this.counter = this.querySelector('.text-limited-counter');
    this.previewImageText = this.closest('.popup-modal__content-info').querySelector('.modal-engraving__preview-image-text');

    this.input.addEventListener('input', this.updateInformations.bind(this));
  }

  updateInformations(){
    this.updateCounter();
    this.updatePreviewImageText();
  }

  updateCounter(){
    this.counter.textContent = `${this.input.value.length}/${this.counter.dataset.maxCharacters}`;
  }

  updatePreviewImageText(){
    if(!this.previewImageText) return;

    this.previewImageText.textContent = this.input.value;
  }
}
customElements.define('text-limited', TextLimited);

class EngravingFont extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.fonts = this.querySelectorAll('input');
    this.previewImageText = this.closest('.popup-modal__content-info').querySelector('.modal-engraving__preview-image-text');

    this.fonts.forEach(font => {
      font.addEventListener('change', () => {
        this.handleFontChange(font);
      });
    });
  }

  handleFontChange(font){
    if(!this.previewImageText) return;
    
    this.previewImageText.style.fontFamily = `'${font.value}'`;
  }
}
customElements.define('engraving-font', EngravingFont);

class EngravingSubmit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.modalContainer = this.closest('.popup-modal__content-info');
    this.button = this.querySelector('button[type="button"]');

    if(!this.button) return;
    this.button.addEventListener('click', this.handleSubmit.bind(this));
  }

  handleSubmit(){
    const context = this.modalContainer.getAttribute('data-context');

    switch(context){
      case 'product-page':
        this.handleProductPageSubmit();
        break;
      case 'cart-edit':
        this.handleCartEditSubmit();
        break;
    }
  }

  handleCartEditSubmit(){
    const errorMessage = document.querySelector('.text-limited-required');
    const inputTextLimited = this.modalContainer.querySelector('text-limited input');

    if(inputTextLimited.value.length === 0){
      errorMessage.classList.remove('hidden');
      return;
    }

    const lineIndex = this.modalContainer.getAttribute('data-line-index');
    const cartDrawerItems = document.querySelector('cart-drawer-items');

    const variantId = this.modalContainer.getAttribute('data-variant-id');
    const textKey = this.modalContainer.getAttribute('data-text-key');
    const fontKey = this.modalContainer.getAttribute('data-font-key');

    cartDrawerItems.updateProperties(lineIndex, {
      [textKey]: this.modalContainer.querySelector('text-limited input').value,
      [fontKey]: this.modalContainer.querySelector('engraving-font input:checked').value
    }, variantId);

    this.resetModalEngraving();
  }

  handleProductPageSubmit(){
    const fromModalQuickAdd = document.querySelector('.quick-add-modal[open]');
    let buttonToClick;

    if(fromModalQuickAdd){
      buttonToClick = fromModalQuickAdd.querySelector('.product-form__submit');
    }
    else{
      buttonToClick = document.querySelector('.product-form__submit');
    }

    const errorMessage = this.modalContainer.querySelector('.text-limited-required');
    const inputTextLimited = this.modalContainer.querySelector('text-limited input');
    
    const productFormInputId = document.querySelector('.product-form:has(.product-form__submit)').querySelector('input[name="id"]').value;
    const inputParentId = this.modalContainer.querySelector('.engraving-parent-id');

    if(inputTextLimited.value.length === 0){
      errorMessage.classList.remove('hidden');
      return;
    }

    errorMessage.classList.add('hidden');
    inputParentId.value = productFormInputId;
    buttonToClick.click();

    this.resetModalEngraving();
  }

  resetModalEngraving(){
    this.closest('.popup-modal').hide();
    this.closest('.popup-modal__content-info').innerHTML = '';
  }
}
customElements.define('engraving-submit', EngravingSubmit);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector(':scope > [id^="Slider-"]');
    this.sliderItems = this.slider?.querySelectorAll(':scope > [id^="Slide-"]');
    this.enableSliderLooping = this.dataset.loop === 'true';
    this.currentPageElement = this.querySelector(':scope > .slider-buttons .slider-counter--current');
    this.pageTotalElement = this.querySelector(':scope > .slider-buttons .slider-counter--total');
    this.prevButton = this.querySelector(':scope > .slider-buttons button[name="previous"]');
    this.nextButton = this.querySelector(':scope > .slider-buttons button[name="next"]');
    this.indicators = Array.from(this.querySelectorAll(':scope > .slider-buttons .slider__indicators .slider__indicator')).map((el) => ({element: el}));
    this.videoBtns = Array.from(this.querySelectorAll(':scope > .slider-buttons .product__media-videos .product__media-videos--item')).map((el) => ({element: el}));
    this.isClickToDrag = this.classList.contains('slider-component--click-to-drag');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.resizeObserver = new ResizeObserver(() => this.initPages());
    this.resizeObserver.observe(this.slider);

    this.sliderScrollListener = this.update.bind(this);
    this.buttonClickListener = this.onButtonClick.bind(this);

    this.slider.addEventListener('scroll', this.sliderScrollListener);
    this.prevButton.addEventListener('click', this.buttonClickListener);
    this.nextButton.addEventListener('click', this.buttonClickListener);
    this.indicators.forEach((it, i) => {
      it.listener = this.onIndicatorClick.bind(this, i);
      it.element.addEventListener('click', it.listener);
    });
    this.videoBtns.forEach((it) => {
      it.listener = this.onIndicatorClick.bind(this, parseInt(it.element.dataset.position));
      it.element.addEventListener('click', it.listener);
    });

    if (this.isClickToDrag) {
      let startingPos = null;
      let startingScrollLeft = null;

      this.clickToDragMouseDownListener = (e) => {
        startingPos = e.clientX;
        startingScrollLeft = this.slider.scrollLeft;
      };

      this.clickToDragMouseUpListener = () => {
        startingPos = null;
        startingScrollLeft = null;
        this.onIndicatorClick(this.currentPage - 1);
        setTimeout(() => {
          this.classList.remove('slider-component--dragging');
        }, 200);
      };

      this.clickToDragMouseMoveListener = (e) => {
        if (startingPos === null) return;
        const diff = e.clientX - startingPos;
        if (Math.abs(diff) > 30) this.classList.add('slider-component--dragging');
        this.slider.scrollTo({ left: startingScrollLeft - diff, behavior: 'instant' })
      };

      this.slider.addEventListener('mousedown', this.clickToDragMouseDownListener);
      document.addEventListener('mouseup', this.clickToDragMouseUpListener);
      document.addEventListener('mousemove', this.clickToDragMouseMoveListener);
    }

    this.mediaQuery = window.matchMedia('screen and (max-width: 749px)');
    this.isIndicatorListenerActive = this.mediaQuery.matches;

    this.mediaQueryListener = (e) => {
      this.isIndicatorListenerActive = e.matches;
    };

    this.mediaQuery.addEventListener('change', this.mediaQueryListener);
  }

  disconnectedCallback() {
    if (this.resizeObserver)
      this.resizeObserver.disconnect();
    if (this.slider)
      this.slider.removeEventListener('scroll', this.sliderScrollListener);
    if (this.prevButton)
      this.prevButton.removeEventListener('click', this.buttonClickListener);
    if (this.nextButton)
      this.nextButton.removeEventListener('click', this.buttonClickListener);
    if (this.indicators)
      this.indicators.forEach((it) => it.element.removeEventListener('click', it.listener));
    if (this.videoBtns)
      this.videoBtns.forEach((it) => it.element.removeEventListener('click', it.listener));
    if (this.mediaQuery)
      this.mediaQuery.removeEventListener('change', this.mediaQueryListener);

    if (this.isClickToDrag) {
      this.slider.removeEventListener('mousedown', this.clickToDragMouseDownListener);
      document.removeEventListener('mouseup', this.clickToDragMouseUpListener);
      document.removeEventListener('mousemove', this.clickToDragMouseMoveListener);
    }

    this.slider = undefined;
    this.sliderItems = undefined;
    this.currentPageElement = undefined;
    this.pageTotalElement = undefined;
    this.prevButton = undefined;
    this.nextButton = undefined;
    this.indicators = undefined;
    this.videoBtns = undefined;
    this.resizeObserver = undefined;

    this.sliderScrollListener = undefined;
    this.buttonClickListener = undefined;
    this.mediaQueryListener = undefined;

    if (this.isClickToDrag) {
      this.clickToDragMouseDownListener = undefined;
      this.clickToDragMouseUpListener = undefined;
      this.clickToDragMouseMoveListener = undefined;
    }
  }

  initPages() {    
    try {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    } catch (error) {
        console.error('Une erreur est survenue :', error.message);
    } finally {

    }
  }

  resetPages() {
    this.sliderItems = this.slider.querySelectorAll(':scope > [id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    this.indicators.forEach((indicator, index) => {
      if(index <= this.totalPages - 1) {
        indicator.element.classList.remove('hidden');
      }
    });

    if (this.currentPage != previousPage) {
      if (this.indicators.length > 0) this.updateCurrentIndicator();

      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  updateCurrentIndicator() {
    if (!this.isIndicatorListenerActive) return;
    this.indicators.forEach((indicator) => {
      if (!indicator.classList) indicator = indicator.element;
      indicator?.classList.remove('slider__indicator--active');
    });
    let previousIndicator = this.indicators[this.currentPage - 1];
    if (!previousIndicator.classList) previousIndicator = previousIndicator.element;
    previousIndicator?.classList.add('slider__indicator--active');
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  onIndicatorClick(i) {
    this.slideScrollPosition = this.sliderItemOffset * i;
    this.setSlidePosition(this.slideScrollPosition);
    
    this.indicators.forEach((indicator) => {
      indicator.element.classList.remove('slider__indicator--active');
    });
    this.indicators[i].element.classList.add('slider__indicator--active');
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide, :scope > .slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinkClickListener = this.linkToSlide.bind(this);
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.sliderControlLinkClickListener));
    this.slideshowScrollListener = this.setSlideVisibility.bind(this);
    this.slider.addEventListener('scroll', this.slideshowScrollListener);
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotionChangeListener = () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      };
      this.reducedMotion.addEventListener('change', this.reducedMotionChangeListener);

      this.announcementBarButtonClickListener = () => {
        this.announcementBarArrowButtonWasClicked = true;
      };
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', this.announcementBarButtonClickListener, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  disconnectedCallback() {
    if (this.sliderControlLinksArray)
      this.sliderControlLinksArray.forEach((link) => link.removeEventListener('click', this.sliderControlLinkClickListener));
    if (this.slider)
      this.slider.removeEventListener('scroll', this.slideshowScrollListener);

    if (this.reducedMotion) {
      this.reducedMotion.removeEventListener('change', this.reducedMotionChangeListener)
    }

    if (this.sliderFocusInListener) {
      this.removeEventListener('mouseover', this.sliderFocusInListener);
      this.removeEventListener('focusin', this.sliderFocusInListener);
    }

    if (this.sliderFocusOutListener) {
      this.removeEventListener('mouseleave', this.sliderFocusOutListener);
      this.removeEventListener('focusout', this.sliderFocusOutListener);
    }

    if (this.sliderAutoplayButtonClickListener) {
      this.sliderAutoplayButton.removeEventListener('click', this.sliderAutoplayButtonClickListener);
    }

    if (this.announcementBarButtonClickListener) {
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', this.announcementBarButtonClickListener, { once: true });
      });
    }

    this.sliderControlLinkClickListener = undefined;
    this.slideshowScrollListener = undefined;
    this.reducedMotionChangeListener = undefined;
    this.sliderFocusInListener = undefined;
    this.sliderFocusOutListener = undefined;
    this.sliderAutoplayButtonClickListener = undefined;
    this.announcementBarButtonClickListener = undefined;

    this.sliderControlWrapper = undefined;
    this.sliderFirstItemNode = undefined;
    this.announcementBarSlider = undefined;
    this.sliderControlLinksArray = undefined;
    this.reducedMotion = undefined;

    super.disconnectedCallback();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderFocusInListener = this.focusInHandling.bind(this);
    this.sliderFocusOutListener = this.focusOutHandling.bind(this);
    this.addEventListener('mouseover', this.sliderFocusInListener);
    this.addEventListener('mouseleave', this.sliderFocusOutListener);
    this.addEventListener('focusin', this.sliderFocusInListener);
    this.addEventListener('focusout', this.sliderFocusOutListener);

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButtonClickListener = this.autoPlayToggle.bind(this);
      this.sliderAutoplayButton.addEventListener('click', this.sliderAutoplayButtonClickListener);
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updatePriceATC();


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updatePriceATC() {
    const priceATC = document.querySelectorAll('.product-form__submit-price');
    if (priceATC.length === 0) return;

    if(this.currentVariant.available) {
      priceATC.forEach(price => price.textContent = formatPrice(this.currentVariant.price));
      priceATC.forEach(price => price.classList.remove('hidden'));
    } else {
      priceATC.forEach(price => price.classList.add('hidden'));
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const stickyDestination = document.getElementById(`price-${this.dataset.section}-sticky`);
        const stickySource = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-sticky`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const addButtonLabel = document.querySelector(`[for="ProductSubmitButton-${this.dataset.section}"]`);
    const klaviyoButton = productForm.querySelector('#klaviyo-bis');
    const preorderMessageElement = productForm.querySelector('.product-form__preorder-message');
    const preorderButtonLabel = addButton.dataset.preOrderButtonLabel || window.variantStrings.preOrder;

    const productId = productForm.querySelector('[name="product-id"]').value;
    const variantsMetafieldsJsonElement = document.getElementById(`VariantsMetafieldsJson-${productId}`);
    let isPreorder = false;
    let preorderMessage = '';
    if (variantsMetafieldsJsonElement) {
      const variantsMetafieldsJson = JSON.parse(variantsMetafieldsJsonElement.textContent);
      const currentVariantMetafieldsJson = variantsMetafieldsJson?.find((variant) => variant.id === this.currentVariant.id);      
      if ((currentVariantMetafieldsJson && currentVariantMetafieldsJson.preorder === true) || addButton.dataset.preOrder === 'true') {        
        isPreorder = true;
        preorderMessage = currentVariantMetafieldsJson.message;
      }
    }    

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (addButtonLabel) {
        addButtonLabel.classList.add('disabled')
        if (text) addButtonLabel.textContent = text;
      }
      if (klaviyoButton) klaviyoButton.style.display = 'block';
      if (preorderMessageElement) preorderMessageElement.classList.add('hidden');
    } else {
      addButton.removeAttribute('disabled');
      if (!isPreorder) {
        addButtonText.textContent = window.variantStrings.addToCart;
      } else {
        addButtonText.textContent = preorderButtonLabel;
        if (preorderMessage !== '') preorderMessageElement.textContent = preorderMessage;
        if (preorderMessageElement) preorderMessageElement.classList.remove('hidden');
      } 
      if (addButtonLabel) {
        addButtonLabel.classList.remove('disabled');
        if (!isPreorder) {
          addButtonLabel.textContent = window.variantStrings.addToCart;
        } else {
          addButtonLabel.textContent = preorderButtonLabel;
        }
      }
      if (klaviyoButton) klaviyoButton.style.display = 'none';
    }

    if (!modifyClass) return;
  }

  toggleAddButtons(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');
    const addButtonTexts = productForm.querySelectorAll('[name="add"] > span');
    const klaviyoButton = productForm.querySelector('.btn-klaviyo-sticky');
    const addButtonPayment = productForm.querySelector('.shopify-payment-button');
    let estimationContainer = document.querySelector('.livraison-estime__calcul');
    let addButtonWithUpsell = document.querySelector('.customStickyATC--Upsell');

    if (!addButtons) return;

    for (var i = 0; i < addButtons.length; i++) {
      if (disable) {
        addButtons[i].setAttribute('disabled', 'disabled');
        if (addButtonPayment != null) { addButtonPayment.style.display = 'none' };
        if (estimationContainer != null) {
          estimationContainer.innerHTML = 'Actuellement indisponible';
        }
        if (addButtonWithUpsell != null) {
          addButtonWithUpsell.style.display = 'none';
        } else {
          addButtons[i].style.display = 'none';
        }
        if (text) addButtonTexts[i].textContent = text;
        if (klaviyoButton) klaviyoButton.style.display = 'inline-block';
      } else {
        if (klaviyoButton) klaviyoButton.style.display = 'none';
        addButtons[i].removeAttribute('disabled');
        if (addButtonPayment != null) { addButtonPayment.style.display = 'block' };
        if (estimationContainer != null) {
          estimationContainer.innerHTML = ' <strong>Livraison standard <span style="font-weight:bold;">offerte </span></strong>' + "estimée entre le: " + `<span> ${formatDate(date.addDays(3))}</span> ` + " et le " + `<span>${formatDate(date.addDays(7))}</span>`;
        }
        if (addButtonWithUpsell != null) {
          addButtonWithUpsell.style.display = 'inline-flex';
        } else {
          addButtons[i].style.display = 'inline-flex';
        }
        addButtonTexts[i].textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CardComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slideshowListener = this.onSliderScroll.bind(this);
    this.slideshow = this.querySelector('slideshow-component');
    this.indicators = Array.from(this.querySelectorAll('.card-product__indicator')).map((el) => ({element: el}));
    this.colorVariants = Array.from(this.querySelectorAll('.card-product__variant')).map((el) => ({element: el, pos: Number(el.dataset.imgPos) - 1}));

    this.slideshow.addEventListener('slideChanged', this.slideshowListener);
    this.indicators.forEach((it, i) => {
      it.listener = this.gotoSlide.bind(this, i);
      it.element.addEventListener('click', it.listener);
    });
    this.colorVariants.forEach((it) => {
      it.listener = this.gotoSlide.bind(this, it.pos);
      it.element.addEventListener('click', it.listener);
    });
  }

  disconnectedCallback() {
    if (this.slideshow)
      this.slideshow.removeEventListener('slideChanged', this.slideshowListener);
    if (this.indicators)
      this.indicators.forEach((it) => it.element.removeEventListener('click', it.listener));
    if (this.colorVariants)
      this.colorVariants.forEach((it) => it.element.removeEventListener('click', it.listener));

    this.slideshowListener = undefined;
    this.slideshow = undefined;
    this.indicators = undefined;
    this.colorVariants = undefined;
  }

  onSliderScroll(event) {
    this.indicators.forEach((it) => it.element.classList.remove('card-product__indicator--active'));
    this.indicators[event.detail.currentPage - 1].element.classList.add('card-product__indicator--active');

    this.colorVariants.forEach((it) => it.element.classList.remove('card-product__variant--active'));

    let lastMatching = null
    for (const colorVariant of this.colorVariants) {
      if (event.detail.currentPage - 1 < colorVariant.pos) break;
      lastMatching = colorVariant.element;
    }
    if (lastMatching) lastMatching.classList.add('card-product__variant--active')
  }

  gotoSlide(i) {
    this.slideshow.slideScrollPosition = this.slideshow.sliderFirstItemNode.clientWidth * i;
    this.slideshow.setSlidePosition(this.slideshow.slideScrollPosition);
  }
}

customElements.define('card-component', CardComponent);

class ButtonCollectionLoadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVariables();
    this.setupEvents();
  }

  setupVariables() {
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector('button.collection__load-more');
    this.nextPage = this.button.dataset.nextPage;
    this.pagination = this.querySelector('.pagination');
  }

  setupEvents() {
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', 'disabled');
    this.button.querySelector('.loading__spinner').classList.remove('hidden');

    let searchParams = new URLSearchParams(window.location.search);
    let url = `${window.location.pathname}?section_id=${this.sectionId}&page=${this.nextPage}`;
    if (searchParams != '') url = `${url}&${searchParams.toString()}`;

    setTimeout(() => {
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          res = res.split('<!-- PRODUCT GRID START -->')[1].split('<!-- PRODUCT GRID END -->')[0];
          const html = new DOMParser().parseFromString(res, 'text/html');
          const newProducts = html.querySelectorAll('#product-grid > .grid__item');
          const newComponent = html.querySelector('button-collection-load-more');
          const newButton = html.querySelector('.collection__load-more');
          const newPagination = html.querySelector('.pagination');

          document.getElementById('product-grid').append(...newProducts);

          if (newComponent) {
            this.outerHTML = newComponent.outerHTML;
          }

          if (!newButton) {
            this.button.remove();
          }

          if (!newPagination) {
            this.pagination.remove();
          }
        })
        .catch(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('disabled');
          this.button.querySelector('.loading__spinner').classList.add('hidden');
        });
    }, 200);
  }
}

customElements.define('button-collection-load-more', ButtonCollectionLoadMore);

class MenuScrollBanners extends HTMLElement {
  constructor() {
    super();

    this.itemsBanner = this.querySelectorAll('.menu-scroll-banner');
    this.itemsMenuLinks = this.querySelectorAll('.menu-scroll-banner__sticky-item');
    this.currentIndex = 1;
    this.indexMax = this.itemsMenuLinks.length;
    this.lineElt = this.querySelector('.menu-scroll-banner__sticky-line .line');
    this.indexElt = this.querySelector('.menu-scroll-banner__sticky-line .index');
  }

  connectedCallback() {
    this.setIntersectionObserver();
    this.setMenuLinksListeners();
  }

  setMenuLinksListeners() {
    this.itemsMenuLinks.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if(item.classList.contains('active')) return;

        const indexToScroll = Number(item.dataset.index);
        
        this.itemsBanner[indexToScroll - 1].scrollIntoView({ behavior: 'smooth', offset: { top: -100 } });
      });
    });
  }

  setIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
          if(entry.isIntersecting){
            this.currentIndex = Number(entry.target.dataset.index);
          }

          this.updateIndex();
      });
    }, {
      rootMargin: '-50% 0px -50% 0px',
    });

    this.itemsBanner.forEach((item) => {
      observer.observe(item);
    });
  }

  updateIndex() {
    this.itemsMenuLinks.forEach((item) => {
      item.classList.remove('active');
    });
    this.itemsMenuLinks[this.currentIndex - 1].classList.add('active');
    this.indexElt.textContent = this.currentIndex;

    this.updateLineHeight();
  }

  updateLineHeight() {
    const maxHeight = screen.width > 750 || window.innerWidth > 750 ? 80 : 100;
    
    const lineHeight = maxHeight / this.currentIndex;
    
    this.lineElt.style.height = `${lineHeight}%`;

    if(this.currentIndex === this.indexMax) {
      this.lineElt.style.height = 0;
      this.indexElt.style.opacity = 0.6;
    } else{
      this.indexElt.style.opacity = 1;
    }
  }
}

customElements.define('menu-scroll-banners', MenuScrollBanners);

const trustpilotWidget = document.querySelector(".trustpilot-wrapper");
trustpilotWidget?.addEventListener('click', reviewsAnchor);

function reviewsAnchor() {
  const anchor = document.getElementById('accordion-reviews');

  if(anchor) {
    anchor.scrollIntoView({ behavior: 'smooth', offset: { top: -100 } });
    
    const details = anchor.querySelector('details');
    if(details && !details.hasAttribute('open')) {
      details.open = true;
    }
  }
}

class VideoJS extends HTMLElement {
  constructor() {
    super();

    this.playPauseButton = this.querySelector('.popup-box-video-button__play-pause');
    this.video = this.querySelector('video');
  }

  connectedCallback() {
    this.playPauseButton.addEventListener('click', this.togglePlayPause.bind(this));
  }

  togglePlayPause() {
    if(this.playPauseButton.getAttribute('action') === 'play') {
      this.playPauseButton.setAttribute('action', 'pause');
      this.video.play();
    } else {
      this.playPauseButton.setAttribute('action', 'play');
      this.video.pause();
    }
  }
}

customElements.define('video-js', VideoJS);